import apiClient from "./config";
import { MAILBOX_ENDPOINTS } from "./endpoints";

export const getMailDetails = () => apiClient.get(MAILBOX_ENDPOINTS.GET_MAIL_DETAILS);
export const deleteMail = (forId) => apiClient.delete(MAILBOX_ENDPOINTS.DELETE_MAIL, { headers: { forId } });

